export default __webpack_public_path__ + "static/tooltip-interactive-2-dont-light-50233c716f66907d831592951a8aefe1.png";